import {
  convertDateToEpoch,
  convertDateToEpochUTC,
} from "../../../../helper/DateConverters";

export const defaultFormValues = {
  site: null,
  completedBy: {
    displayName: localStorage.displayName,
    userID: localStorage.userID,
  },
  date: convertDateToEpochUTC(new Date(new Date().setHours(0, 0, 0, 0))),
  dateTime: convertDateToEpoch(new Date()),
  loweringEquipment: [
    {
      label: "Rope Free from Damage?",
      value: null,
      name: "ropeFreeDamage",
    },
    {
      label: "All associated equipment free from damage?",
      value: null,
      name: "allAssociatedEquipmentFree",
    },
    {
      label: "All mechanical parts are functioning?",
      value: null,
      name: "allMechanicalPartsFunctioning",
    },
    {
      label: "Rope is not showing any damage or wear?",
      value: null,
      name: "ropeNotShowingDamage",
    },
  ],
  surveyEquipment: [
    {
      label:
        "Survey Equipment is suitable for use with no clear signs of damage?",
      value: null,
      name: "surveyEquipmentSuitable",
    },
    {
      label: "All connections are correct and free from damage?",
      value: null,
      name: "allConnectionsCorrect",
    },
    {
      label: "Cables and wires free from twisting and damage?",
      value: null,
      name: "cablesAndWiresFree",
    },
    {
      label: "Equipment confirmed as safe for use?",
      value: null,
      name: "equipmentConfirmedSafe",
    },
  ],
};
